import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StorageAccountsDetailsWrapper = styled(Grid)(() => ({
  padding: "8px",
}));

export const StorageAccountsDetailsTitle = styled("span")(() => ({
  color: "#1D2939",
  fontSize: "16px",
  fontFamily: "Manrope",
  fontWeight: 700,
  lineHeight: "150%",
  marginBottom: "16px",
}));

export const DetailsFieldsContainer = styled(Grid)(() => ({
  marginBottom: "8px",
}));

export const CommentsContainer = styled(Grid)(() => ({
  marginTop: "-16px",
}));

export const Separator = styled("hr")(() => ({
  width: "100%",
  height: 0,
  margin: "16px 0",
}));
